<aside class="side-nav md:block hidden" [class.side-nav--collapsed]="collapsed">
  <div class="side-nav__header">
    <div class="side-nav__brand" [class.justify-center]="collapsed">
      @if (logo) {
        <div class="side-nav__logo">
          <img [src]="logo" alt="brand logo">
        </div>
      } @else {
        <div class="side-nav__logo">
          <span>V</span>
        </div>
      }

      <div class="side-nav__brand-text" *ngIf="!collapsed">
        <h1>{{ brandTitle }}</h1>
        <p>{{ brandSubtitle }}</p>
      </div>
    </div>

    <button
      type="button"
      class="side-nav__toggle"
      (click)="toggleCollapse()"
      [attr.aria-label]="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
    >
      <svg
        class="h-5 w-5 transition-transform duration-300"
        [class.rotate-180]="collapsed"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
      >
        <path
          d="M15 18l-6-6 6-6"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
    </button>
  </div>

  <nav class="side-nav__menu">
    <ul class="side-nav__list">
      @for (item of menuItems$ | async; track $index; let i = $index) {
        @if (!item.permissions || item.permissions.length === 0 || authService.hasAnyPermission(item.permissions)) {
          <li>
            @if (item.children) {
              <div
                class="side-nav__link cursor-pointer"
                [class.side-nav__link--collapsed]="collapsed"
                [class.is-active]=""
                [attr.title]="collapsed ? item.label : null"
                (click)="onToggleParentItem(i)"
              >
                <div class="side-nav__link-content">
                  <span class="side-nav__icon">
                    <ng-container [ngSwitch]="item.icon">
                      <svg
                        *ngSwitchCase="'dashboard'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <rect x="3" y="3" width="7" height="7" rx="1"></rect>
                        <rect x="14" y="3" width="7" height="7" rx="1"></rect>
                        <rect x="3" y="14" width="7" height="7" rx="1"></rect>
                        <rect x="14" y="14" width="7" height="7" rx="1"></rect>
                      </svg>
      
                      <svg
                        *ngSwitchCase="'users'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9.5" cy="7" r="3"></circle>
                        <path d="M20 8v6"></path>
                        <path d="M23 11h-6"></path>
                      </svg>
      
                      <svg
                        *ngSwitchCase="'check-circle'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <circle cx="12" cy="12" r="9"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
      
                      <svg
                        *ngSwitchCase="'credit-card'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <rect x="2" y="5" width="20" height="14" rx="2"></rect>
                        <path d="M2 10h20"></path>
                      </svg>
      
                      <svg
                        *ngSwitchCase="'file-text'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <path d="M14 2v6h6"></path>
                        <path d="M8 13h8"></path>
                        <path d="M8 17h6"></path>
                      </svg>
      
                      <svg
                        *ngSwitchCase="'bar-chart'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <path d="M3 21h18"></path>
                        <path d="M7 16v-5"></path>
                        <path d="M12 16V8"></path>
                        <path d="M17 16v-9"></path>
                      </svg>
      
                      <svg
                        *ngSwitchCase="'settings'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <circle cx="12" cy="12" r="3"></circle>
                        <path
                          d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1 .6 1.65 1.65 0 0 0-.33 1V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-.33-1 1.65 1.65 0 0 0-1-.6 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-.6-1 1.65 1.65 0 0 0-1-.33H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1-.33 1.65 1.65 0 0 0 .6-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6c.39-.23.7-.58.9-1A1.65 1.65 0 0 0 10.24 3H10a2 2 0 1 1 4 0h.09c.43 0 .84.12 1.2.35.39.23.7.58.9 1a1.65 1.65 0 0 0 1.82.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9c.23.39.35.8.35 1.2V10a2 2 0 1 1 0 4h-.09c-.43 0-.84.12-1.2.35-.39.23-.7.58-.9 1z"
                        ></path>
                      </svg>
      
                      <svg
                        *ngSwitchCase="'shield'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                      </svg>
      
                      <svg
                        *ngSwitchDefault
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <circle cx="12" cy="12" r="9"></circle>
                      </svg>
                    </ng-container>
                  </span>
      
                  <span class="side-nav__label" *ngIf="!collapsed">
                    {{ item.label }}
                  </span>
                </div>
      
                <span
                  *ngIf="item.badgeCount && !collapsed"
                  class="side-nav__badge"
                >
                  {{ item.badgeCount }}
                </span>
      
                <span
                  *ngIf="item.badgeCount && collapsed"
                  class="side-nav__badge-dot"
                ></span>
              </div>
    
              <!-- Drop down -->
              <div [class]="{
                'side-nav__child-container': true,
                'side-nav__child-container-hidden': dropdownItemIndex !== i
              }">
                @for (child of item.children; track $index) {
                  <div
                    [routerLink]="child.route"
                    routerLinkActive="is-active"
                    #rla="routerLinkActive"
                    [routerLinkActiveOptions]="{ exact: child.exact ?? false }"
                    class="side-nav__child-item"
                  >
                    <div class="side-nav__link-content">
                      <span class="side-nav__icon">
                        <ng-container [ngSwitch]="child.icon">
                          <svg
                            *ngSwitchCase="'dashboard'"
                            class="size-5"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                          >
                            <rect x="3" y="3" width="7" height="7" rx="1"></rect>
                            <rect x="14" y="3" width="7" height="7" rx="1"></rect>
                            <rect x="3" y="14" width="7" height="7" rx="1"></rect>
                            <rect x="14" y="14" width="7" height="7" rx="1"></rect>
                          </svg>
          
                          <svg
                            *ngSwitchCase="'users'"
                            class="h-5 w-5"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                          >
                            <path d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9.5" cy="7" r="3"></circle>
                            <path d="M20 8v6"></path>
                            <path d="M23 11h-6"></path>
                          </svg>
          
                          <svg
                            *ngSwitchCase="'check-circle'"
                            class="h-5 w-5"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                          >
                            <circle cx="12" cy="12" r="9"></circle>
                            <path d="m9 12 2 2 4-4"></path>
                          </svg>
          
                          <svg
                            *ngSwitchCase="'credit-card'"
                            class="h-5 w-5"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                          >
                            <rect x="2" y="5" width="20" height="14" rx="2"></rect>
                            <path d="M2 10h20"></path>
                          </svg>
          
                          <svg
                            *ngSwitchCase="'file-text'"
                            class="h-5 w-5"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                          >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <path d="M14 2v6h6"></path>
                            <path d="M8 13h8"></path>
                            <path d="M8 17h6"></path>
                          </svg>
          
                          <svg
                            *ngSwitchCase="'bar-chart'"
                            class="h-5 w-5"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                          >
                            <path d="M3 21h18"></path>
                            <path d="M7 16v-5"></path>
                            <path d="M12 16V8"></path>
                            <path d="M17 16v-9"></path>
                          </svg>
          
                          <svg
                            *ngSwitchCase="'settings'"
                            class="h-5 w-5"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                          >
                            <circle cx="12" cy="12" r="3"></circle>
                            <path
                              d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1 .6 1.65 1.65 0 0 0-.33 1V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-.33-1 1.65 1.65 0 0 0-1-.6 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-.6-1 1.65 1.65 0 0 0-1-.33H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1-.33 1.65 1.65 0 0 0 .6-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6c.39-.23.7-.58.9-1A1.65 1.65 0 0 0 10.24 3H10a2 2 0 1 1 4 0h.09c.43 0 .84.12 1.2.35.39.23.7.58.9 1a1.65 1.65 0 0 0 1.82.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9c.23.39.35.8.35 1.2V10a2 2 0 1 1 0 4h-.09c-.43 0-.84.12-1.2.35-.39.23-.7.58-.9 1z"
                            ></path>
                          </svg>
          
                          <svg
                            *ngSwitchCase="'shield'"
                            class="h-5 w-5"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                          >
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                          </svg>
          
                          <svg
                            *ngSwitchDefault
                            class="h-5 w-5"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                          >
                            <circle cx="12" cy="12" r="9"></circle>
                          </svg>
                        </ng-container>
                      </span>
          
                      <span class="side-nav__label" *ngIf="!collapsed">
                        {{ child.label }}
                      </span>
                    </div>
        
                    <span
                      *ngIf="child.badgeCount && !collapsed"
                      class="side-nav__badge"
                    >
                      {{ child.badgeCount }}
                    </span>
          
                    <span
                      *ngIf="child.badgeCount && collapsed"
                      class="side-nav__badge-dot"
                    ></span>
                  </div>
                }
              </div>
            } @else {
              <a
              [routerLink]="item.route"
              routerLinkActive="is-active"
              #rla="routerLinkActive"
              (isActiveChange)="shouldParentItem($event)"
              [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
              class="side-nav__link"
              [class.side-nav__link--collapsed]="collapsed"
              [attr.title]="collapsed ? item.label : null"
              >
                <div class="side-nav__link-content">
                  <span class="side-nav__icon">
                    <ng-container [ngSwitch]="item.icon">
                      <svg
                        *ngSwitchCase="'dashboard'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <rect x="3" y="3" width="7" height="7" rx="1"></rect>
                        <rect x="14" y="3" width="7" height="7" rx="1"></rect>
                        <rect x="3" y="14" width="7" height="7" rx="1"></rect>
                        <rect x="14" y="14" width="7" height="7" rx="1"></rect>
                      </svg>
    
                      <svg
                        *ngSwitchCase="'users'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9.5" cy="7" r="3"></circle>
                        <path d="M20 8v6"></path>
                        <path d="M23 11h-6"></path>
                      </svg>
    
                      <svg
                        *ngSwitchCase="'check-circle'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <circle cx="12" cy="12" r="9"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
    
                      <svg
                        *ngSwitchCase="'credit-card'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <rect x="2" y="5" width="20" height="14" rx="2"></rect>
                        <path d="M2 10h20"></path>
                      </svg>
    
                      <svg
                        *ngSwitchCase="'file-text'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <path d="M14 2v6h6"></path>
                        <path d="M8 13h8"></path>
                        <path d="M8 17h6"></path>
                      </svg>
    
                      <svg
                        *ngSwitchCase="'bar-chart'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <path d="M3 21h18"></path>
                        <path d="M7 16v-5"></path>
                        <path d="M12 16V8"></path>
                        <path d="M17 16v-9"></path>
                      </svg>
    
                      <svg
                        *ngSwitchCase="'settings'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <circle cx="12" cy="12" r="3"></circle>
                        <path
                          d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1 .6 1.65 1.65 0 0 0-.33 1V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-.33-1 1.65 1.65 0 0 0-1-.6 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-.6-1 1.65 1.65 0 0 0-1-.33H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1-.33 1.65 1.65 0 0 0 .6-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6c.39-.23.7-.58.9-1A1.65 1.65 0 0 0 10.24 3H10a2 2 0 1 1 4 0h.09c.43 0 .84.12 1.2.35.39.23.7.58.9 1a1.65 1.65 0 0 0 1.82.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9c.23.39.35.8.35 1.2V10a2 2 0 1 1 0 4h-.09c-.43 0-.84.12-1.2.35-.39.23-.7.58-.9 1z"
                        ></path>
                      </svg>
    
                      <svg
                        *ngSwitchCase="'shield'"
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                      </svg>
    
                      <svg
                        *ngSwitchDefault
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                      >
                        <circle cx="12" cy="12" r="9"></circle>
                      </svg>
                    </ng-container>
                  </span>
    
                  <span class="side-nav__label" *ngIf="!collapsed">
                    {{ item.label }}
                  </span>
                </div>
    
                <span
                  *ngIf="item.badgeCount && !collapsed"
                  class="side-nav__badge"
                >
                  {{ item.badgeCount }}
                </span>
    
                <span
                  *ngIf="item.badgeCount && collapsed"
                  class="side-nav__badge-dot"
                ></span>
              </a>
            }
          </li>
        }
      }
    </ul>
  </nav>
  <div>
  </div>
</aside>
